import getUserAdvancedStore from "../../../../stores/user-store/advanced-store";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import UserCounterIndex from "./user-counter-index";
import UserDetailsBox from "./user-details-box";
import UserDetailsTable from "./user-table";
import UserCommentsBox from "./user-comment-box";
import ModifyUserData from "./modify-user-data";
import i18n from "../../../../constants/i18n";
import Et3Text from "../../../../core/et3-text";
import ActiveFeatureSets from "./active-feature-sets";
import ActiveFeatures from "./active-features";
import ActiveFeaturesByFeatureSets from "./active-features-by-feature-sets/index";

const UserAdvancedData = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;
  const isVisible = getUserAdvancedStore().userIDs.get().length > 0;
  const { userIsUnderCsrInvestigation } =
    getUserAdvancedStore().currentUserIsUnderCsrInvestigation.get();

  return isVisible ? (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={1500}
      height={100}
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <UserCounterIndex />
      <Et3Margin top={60} bottom={0} left={0} right={0} />
      <UserDetailsBox />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <ActiveFeatureSets />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <ActiveFeatures />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <ActiveFeaturesByFeatureSets />
      <Et3Margin top={10} bottom={0} left={0} right={0} />
      <UserCommentsBox />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={1500}
        height={30}
        fDirection="column"
        alignItems="flex-start"
        justifyContent="center"
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={20}
          text={i18n.get("USER_ACTION_BUTTONS")}
          isSpan={false}
          color={colors.all.maastrichtBlue}
          style={{}}
        />
      </ET3Div>
      <Et3Margin top={20} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={1500}
        height={50}
        fDirection="column"
        alignItems="center"
        justifyContent="flex-start"
        color={colors.all.white}
        style={{
          borderWidth: 3 * unitX,
          borderRadius: 39 * unitX,
          border: userIsUnderCsrInvestigation
            ? `solid ${colors.all.red}`
            : `solid ${colors.all.lightGray}`
        }}
        onClick={() => {}}
      >
        <ModifyUserData />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <UserDetailsTable />
    </ET3Div>
  ) : null;
});
export default UserAdvancedData;
